import { TrendingUp } from "lucide-react"
import { Bar, BarChart, CartesianGrid, XAxis } from "recharts"

import {
    Card,
    CardContent,
    CardDescription,
    CardFooter,
    CardHeader,
    CardTitle,
} from "@/components/ui/card"
import {
    ChartConfig,
    ChartContainer,
    ChartTooltip,
    ChartTooltipContent,
} from "@/components/ui/chart"
import { useEffect, useState } from "react"
import { BASE_URL } from "@/config"

const chartConfig = {
    transfers: {
        label: "Transfers",
        color: "hsl(var(--chart-1))",
    },
} satisfies ChartConfig

const MostSoldTransfers = () => {

    const [chartData, setChartData] = useState<{ month: string; tours: number }[]>([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {

        const fetchData = async () => {

            try {
                const response = await fetch(`${BASE_URL}/reports-taxi/transfers-by-month`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    }
                })
                if (!response.ok) throw new Error("Failed to fetch data")
                const data = await response.json();
                setChartData(data);
            } catch (error) {
                console.error("Error fetching data:", error)
            } finally {
                setLoading(false)
            }

        }

        fetchData()

    }, [])

    const getLastSixMonthsRange = () => {
        const now = new Date();
        const months: any[] = [];

        for (let i = 5; i >= 0; i--) {
            const date = new Date(now.getFullYear(), now.getMonth() - i, 1);
            const monthName = new Intl.DateTimeFormat("en-US", { month: "long" }).format(date);
            const year = date.getFullYear();
            months.push({ name: monthName, year });
        }

        const first = months[0];
        const last = months[5];

        return `${first.name} ${first.year} - ${last.name} ${last.year}`;
    }

    return (
        <Card>
            <CardHeader>
                <CardTitle>Sold transfers</CardTitle>
                <CardDescription>{getLastSixMonthsRange()}</CardDescription>
            </CardHeader>
            <CardContent>
                <ChartContainer config={chartConfig}>
                    <BarChart accessibilityLayer data={chartData}>
                        <CartesianGrid vertical={false} />
                        <XAxis
                            dataKey="month"
                            tickLine={false}
                            tickMargin={10}
                            axisLine={false}
                            tickFormatter={(value) => value.slice(0, 3)}
                        />
                        <ChartTooltip
                            cursor={false}
                            content={<ChartTooltipContent hideLabel />}
                        />
                        <Bar dataKey="transfers" fill="var(--color-transfers)" radius={8} />
                    </BarChart>
                </ChartContainer>
            </CardContent>
            <CardFooter className="flex-col items-start gap-2 text-sm">
                <div className="leading-none text-muted-foreground">
                    Showing total transfers for the last 6 months
                </div>
            </CardFooter>
        </Card>
    )
}

export default MostSoldTransfers;